export default __webpack_public_path__ + "static/media/english-to-italian-screenshot-02.5f939e65.png";